import Hoist from '@groww-tech-pvt/hoist';
import { isEmpty } from '@groww-tech-pvt/ella';
import { trackEvent } from '../gobbler';
import { GobblerHoistFeatureFetchFailed, GobblerHoistFeatureFetchSuccess } from '@groww-tech-pvt/gobbler-proto-ts/dist';

export const Category = {
  Hoist: 'Hoist'
};


//Hoist Events
export const events = {
  FeatureFetchSuccess: 'FeatureFetchSuccess',
  FeatureFetchFailed: 'FeatureFetchFailed',
  SegmentFetchSuccess: 'SegmentFetchSuccess',
  SegmentFetchFailed: 'SegmentFetchFailed'
};

export const GENERAL_ERROR_CONSTANTS = {
  GENERAL_ERROR: 'Something went wrong. Please try again.'
};


/**
 * initHoistSDK
 *
 *@remarks Initializes hoist sdk with the provided configs
 */
export const initHoistSDK = (sessionId: string, apiUrl: string, clientKey: string) => {

  Hoist.initHoistSDK({
    apiHost: apiUrl,
    clientKey: clientKey,
    baseUrl: apiUrl,
    isDebug: false,
    onFetchSegmentSuccess: () => {
      trackEvent('GobblerHoistSegmentFetchSuccess', GobblerHoistFeatureFetchSuccess, {})
    },
    onFetchSegmentFailed: () => {
      trackEvent('GobblerHoistFeatureFetchFailed', GobblerHoistFeatureFetchFailed, { errorMessage: 'Segment fetch went wrong' })
    },
    onFetchFeatureSuccess: () => {
      trackEvent('GobblerHoistSegmentFetchSuccess', GobblerHoistFeatureFetchSuccess, {})

    },
    onFetchFeatureFailed: () => {
      trackEvent('GobblerHoistFeatureFetchFailed', GobblerHoistFeatureFetchFailed, { errorMessage: 'Something feature went wrong' })

    }
  });

  //when user closes the tab and comes back , segments fetching api will be called
  if (!isEmpty(sessionId)) {
    Hoist.updateUserSegments({
      Authorization: sessionId
    });
  }
};

/**
 * getFEatureValue
 *
 * @param { string } featureKey - The feature key who value is to evaluate
 * @param { string } defaultValue - The default value to return if evaluation fails due to server error or sdk error
 * @returns A promise, that resolves -> evaluated feature value or the default value in case of server error
 *
 * @example getFeatureValue("test-feature",false).then(res => {}).catch(err => {})
 */
export const getFeatureValue = Hoist.getFeatureValue;

/**
 * setUserAttributesAtHoist
 * @remarks - Sets user's attributes to hoist sdk
 * @param { object } attributes - The key value pairs that is to be set to hoist sdk
 *
 * @example setUserAttributesAtHoist({
        userId: 'ACC123456789012'
      });
 */
export const setUserAttributesAtHoist = Hoist.setAttributes;

export const getAttributes = Hoist.getAttributes;

/**
 * setUserAttributesAtHoist
 * @remarks - Fetches all segments that the user belongs to and sets it to user's attributes
 * @param { object } headers - Authoraization header with auth token as value
 * @example updateUserSegmentAtHoist({
          Authorization: `AUTH_TOKEN`
        });
 */
export const updateUserSegmentAtHoist = Hoist.updateUserSegments;

export { useHoistValue } from './hooks/useHoistValue';
